import ROUTES from '../../constants/routes';
import { world } from '../../languages';

export const PROMOTE_APP_TRACK_NAME = 'promote-app-banner';
export const PROMOTE_APP_NAME_V2 = 'promote-app-v2';
export const PROMOTE_APP_RESHOW_DATE = 'promote-app-reshow-date';

export const APPSTORE_URL = 'https://apps.apple.com/app/apple-store/id1523303309?pt=121838604&ct=eduki-banner&mt=8';

export enum PROMOTE_APP_TRACK_EVENTS {
    CLOSE_CLICK = 'close-click',
    DOWNLOAD_CLICK = 'download-click',
    SHOW = 'show'
}

export const PROMOTE_APP_ALLOWED_ROUTES = [
    ROUTES.SEARCH_RESULT.path,
    ROUTES.MATERIAL.prefixes[world],
    ROUTES.MATERIAL.defaultPrefix,
    ROUTES.SCHOOL_LANDING_PAGES.prefixes[world],
    ROUTES.SCHOOL_LANDING_PAGES.defaultPrefix,
    ROUTES.FAVORITES.path,
    ROUTES.THANK_YOU_PAGE.path
];
